import { render } from "./Bancos.vue?vue&type=template&id=c6728d30"
import script from "./Bancos.vue?vue&type=script&lang=js"
export * from "./Bancos.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__